import React, { FC } from "react";
import styled from "styled-components";
import { loadingColour, loadingTextColour, loadingSpin } from "../env";

interface Props {
  progress: number;
  className?: string;
}

const LoadingScreen: FC<Props> = ({ progress, className }) => {
  return (
    <LoadingBackground className={className || ""}>
      <LoadingDiv>
        <LoadingImage src="android-chrome-512x512.png" />
        <LoadingBar>
          <LoadingFill style={{ width: `${progress * 100}%` }} />
        </LoadingBar>
      </LoadingDiv>
    </LoadingBackground>
  );
};

const LoadingBackground = styled.div`
  width: 100%;
  height: 100%;
  background: ${loadingColour};
  color: ${loadingTextColour};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingDiv = styled.div``;

const StaticLoadingImage = styled.img`
  max-width: 12em;
  max-height: 12em;
  margin-bottom: 1em;
`;

const SpinningLoadingImage = styled(StaticLoadingImage)`
  animation: spin 3s infinite linear;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingImage = loadingSpin ? SpinningLoadingImage : StaticLoadingImage;

const LoadingBar = styled.div`
  width: 20em;
  height: 2em;
  border: 0.25em solid ${loadingTextColour};
`;

const LoadingFill = styled.div`
  height: 100%;
  background: ${loadingTextColour};
`;

export { LoadingScreen };
